const baseUrl = process.env.REACT_APP_BASE_URL;
const version = process.env.REACT_APP_VERSION;

const restUrl = () => {
    return `${baseUrl}${version}`;
}

const ApiService = {
    restUrl
};

export const getErrorMessage = (error) => {
    return (
        error?.data?.error?.message ||
        error?.message ||
        'Something went wrong. Please try again.'
    );
};

export default ApiService;